import { NomenclatureBaseFormDto, type NomenclatureBaseFormInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-base-form.dto';
import { NomenclatureTypeEnum } from '@zaoblako/shared/modules/catalog/enums/nomenclature-type.enum';
import { NomenclatureTypeEnumI18n } from '@zaoblako/shared/modules/catalog/i18n/nomenclature-type-enum.i18n';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { NomenclatureGroupFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-group-find.dto';

import * as yup from 'yup';

/** Nomenclature item create and update request body */
export interface NomenclatureItemFormInterface extends NomenclatureBaseFormInterface {
  /** Item type */
  type: NomenclatureTypeEnum;
  /** Item price */
  price: number;
  /** Group this item belongs to */
  group?: NomenclatureGroupFindInterface;
}

/** Nomenclature item create and update request body - DTO schema */
export const NomenclatureItemFormDto = SerdeDtoClass.from<NomenclatureBaseFormInterface, NomenclatureItemFormInterface>(
  NomenclatureBaseFormDto,
  CatalogDtosKeysEnum.NOMENCLATURE_ITEM_FORM_DTO,
  {
    type: {
      label: 'Тип',
      serializer: commonEnumValidator(NomenclatureTypeEnum, NomenclatureTypeEnumI18n),
    },
    price: {
      label: 'Цена',
      serializer: yup
        .number()
        .min(0, DtoMessageEnum.NOT_ZERO_OR_POSITIVE),
    },
    group: {
      optional: true,
      label: 'Группа',
      serializer: entityLikeSchema,
      checkers: [CatalogCheckersEnum.NOMENCLATURE_GROUP_ASSERT_EXISTS_BY_DTO],
    },
  },
);
